import {type TimeZone} from '@hconnect/common/types'
import {CalendarDatePicker, CalendarDatePickerRange} from '@hconnect/uikit/src/lib2'
import {Box, useMediaQuery, useTheme} from '@mui/material'
import moment, {Moment} from 'moment-timezone'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type PagePerformanceReviewHeaderActionsProps = {
  selectedDate: Moment | undefined
  onSelectedDateChange: (date: Moment) => void
  timezone: TimeZone
  /**
   * Set to `true` when rendered on the legacy blue surface (hproduce app) so the
   * month selector uses on-blue (white) text. Suite renders on the light surface
   * and keeps the default (`false`) for dark, readable text.
   */
  inverted?: boolean
}

export const PagePerformanceReviewHeaderActions = ({
  selectedDate,
  onSelectedDateChange,
  timezone,
  inverted = false
}: PagePerformanceReviewHeaderActionsProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleDateChange = useCallback(
    (date: string | undefined) => {
      if (date) {
        onSelectedDateChange(moment.tz(date, timezone).startOf('month'))
      }
    },
    [onSelectedDateChange, timezone]
  )

  return (
    <Box mt={isMobile ? 2 : 1}>
      <CalendarDatePicker
        selectedDate={selectedDate?.format('YYYY-MM-DD')}
        timeZone={timezone}
        fullWidth={isMobile}
        setSelectedDate={handleDateChange}
        type={CalendarDatePickerRange.Monthly}
        label={t('filters.label.month')}
        contrastingText={!inverted}
      />
    </Box>
  )
}
